function attachStopEvents(link) {
  link.addEventListener('click', evt => {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
  });
}

// Attach to existing submenu links
document.querySelectorAll('.submenu-span a').forEach(attachStopEvents);

// Observe for new submenu links
const observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) { // element node
        if (node.matches('.submenu-span a')) {
          attachStopEvents(node);
        } else if (node.querySelectorAll) {
          node.querySelectorAll('.submenu-span a').forEach(attachStopEvents);
        }
      }
    });
  });
});

// Start observing the whole document for added elements
observer.observe(document.body, {
  childList: true,
  subtree: true
});

